import { Box } from '@achieve/ascend'
import { Typography } from 'components/Contentful'
import classNames from 'classnames'

function CardPhone({ content, breakline }) {
  const { cardTitleText, cardText } = content || {}
  return (
    <Box
      variant="none"
      data-testid="card-container"
      className={classNames(
        'flex flex-col mb-6 lg:mb-0',
        breakline && 'lg:[&_.card-text-title]:mt-0'
      )}
    >
      <Box className={classNames('flex flex-col text-center flex-auto lg:mt-6')}>
        {cardTitleText && (
          <Typography
            data-testid="card-title"
            variant="headingMd"
            fontWeight="medium"
            className="card-text-title mb-4 text-center"
            content={cardTitleText}
          />
        )}

        {cardText && (
          <Typography
            data-testid="card-subtitle"
            className={classNames(
              'mt-2 text-center',
              'headingLg lg:headingMd font-light! lg:font-medium!'
            )}
            component="span"
            content={cardText}
          />
        )}
      </Box>
    </Box>
  )
}

export { CardPhone }
